import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fileActions } from '../../store/actions'
import { groupActorsFunctions } from './GroupActorsFunctions.js'

//// import { mainStyles, theme } from '../../styles'
// import { useStyles } from './GroupActorsStyles.js'

import HelpIcon from '@mui/icons-material/Help';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import PersonIcon from '@mui/icons-material/Person';
import ErrorIcon from '@mui/icons-material/Error';

import {
    CustomCounterAppBar,UseImage,
    CustomAlertHelpDialog,
    CustomAlertMaterial, CustomLoadingOverlay
,Buttons } from '../../components'

import { ListElementforEdit } from './ListElementforEdit.js';

import {
    Typography,
    Menu,
    MenuItem,
    ListItemIcon,useTheme
} from '@mui/material'
import Editar_rolImg from '../../assets/Editar_rol.gif'
import { useTranslation } from 'react-i18next'


export default function EditActorsComponent(props) {
    const gridContainer = {} //mainStyles.gridStyle()
     const theme = useTheme()
    const location = useLocation()
  const classes = {} //mainStyles.bodyStyles()
    const localStyles = {}//useStyles()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [loadView, setLoadView] = useState(false)
    const [openHelp, setOpenHelp] = useState(false)
    const [openAlert, setOpenalert] = useState(false)

    const [actorToDelete, setActorToDelete] = useState('')

    const [idToDelete, setIdToDelete] = useState(null)
    const [indexToChange, setIndexToChange] = useState(0)
    const [anchorEl, setAnchorEl] = useState(null)

    const [actors, setActors] = useState([])
    const [actorOptions, setActorOptions] = useState([])
    const [availableOptions, setAvailableOptions] = useState([])
    const [actorsToSend, setActorsToSend] = useState([])

    const auth = useSelector(state => state.Authentication)
    const file = useSelector(state => state.FileInfo)
    const actorsInfo = useSelector(state => state.Actors)
    const deletedActor = useSelector(state => state.DeletedActor)
    const updatedInfo = useSelector(state => state.UpdatedInfo)
    const folioId = location.state.folioId
    const { t } = useTranslation();

    useEffect(() => {
        dispatch(fileActions.GetActors(folioId))
        setLoadView(true)
    }, [])

    useEffect(() => {
        if (actorsInfo.items != undefined && loadView) {
            setActors(actorsInfo.items.map((actor) => {
                return {
                    Id: actor.Id,
                    FatherLastName: actor.FatherLastName,
                    MotherLastName: actor.MotherLastName,
                    Name: actor.Name,
                    TypeName: actor.TypeName,
                    noRole: false
                }
            }))
            console.log('actores', actorsInfo.items)
            setLoadView(false)
        }
        if (file.items != undefined && file.items?.Stage != undefined) {
            const optionsJson = file.items.Stage.Properties.find((prop) => prop.Name === 'ConfigurationOptions')
            setActorOptions(JSON.parse(optionsJson.Value))
        }
    }, [actorsInfo])

    useEffect(() => {
        if (actorOptions.length > 0 && actors.length > 0) {
            const newOptions = actorOptions.filter((el) => !actors.some((element) => element.TypeName === el.TypeName) || el.MaximumNumberAllowed === -1)
            setAvailableOptions([{ TypeName: 'Sin Rol' }, ...newOptions])
            console.log('newOptions', availableOptions)
        }
    }, [actorOptions, actors])

    const deleteActor = (id) => {
        dispatch(fileActions.RemoveActor(id))
        setLoadView(true)
        setOpenalert(false)
    }

    const goBack = () => {
        const nextComponent = 'GroupActorsComponent'
        groupActorsFunctions.nextStage({ auth ,navigate,nextComponent, folioId })
    }

    useEffect(() => {
        if (deletedActor.items != undefined && loadView) {
            dispatch(fileActions.GetActors(folioId))
            console.log('remove answer', deletedActor.items)
        }
    }, [deletedActor])

    const openAlertToDelete = (id, Name) => {
        setActorToDelete(Name)
        setIdToDelete(id)
        setOpenalert(true)
    }
    const closeAlertToDelete = () => {
        setActorToDelete('')
        setIdToDelete(null)
        setOpenalert(false)
    }

    const setAnchor = (event, i) => {
        setAnchorEl(event.currentTarget)
        console.log('print Index', i)
        setIndexToChange(i)
    }

    const newRole = (type) => {
        setAnchorEl(null)
        let newArr = [...actors]
        newArr[indexToChange].TypeName = type === 'Sin Rol' ? '' : type
        newArr[indexToChange].noRole = type === 'Sin Rol' ? true : false
        setActors(newArr)
        console.log('formChanges', newArr)

    }

    const closeList = () => {
        setAnchorEl(null)
        setIndexToChange(0)
    }

    const sendChange = () => {
        const newActors = actors.map((actor) => {
            return {
                Actor_id: actor.Id,
                TypeName: actor.TypeName,
                ActorIdentifier: null

            }
        })
        setActorsToSend(newActors)
    }

    useEffect(() => {
        if (actorsToSend.length > 0) {
            const bodyTosend = {
                File_Id: folioId,
                ActorRoles: actorsToSend
            }
            dispatch(fileActions.UpdateActorsRole(bodyTosend))
            setLoadView(true)
        }

    }, [actorsToSend])

    useEffect(() => {
        if (updatedInfo.items && loadView) {
            goBack()
        }
    }, [updatedInfo])

    return (
        <div className={gridContainer.container}>
            <div className={gridContainer.leftColumn}></div>
            <div className={gridContainer.centerColumn}>
                <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
                {/* {loadView ? <LoadingOverlay
                    active={loadView}
                    spinner
                    text='Espere un momento por favor...'
                    className={classes.loader}>
                </LoadingOverlay> : null} */}
                <CustomCounterAppBar
                    viewReturn={true}
                    viewMenu={false}
                    backAction={goBack}
                />
                <div className={gridContainer.centerContent1}>
                    <div className={localStyles.titleSection}>
                        <Typography variant='h6'><b>Edición de roles</b></Typography>
                        <HelpIcon style={{ marginLeft: 7 }} onClick={() => { setOpenHelp(true) }} />
                    </div>

                    <Typography variant='subtitle1' className={localStyles.instructions}>
                        Recuerda que hay roles que solo permiten un persona en ese rol. Si alguno de esos roles esta ocupado, primero deberas colocarlo sin rol para una nueva asignación.
                    </Typography>
                    <div className={localStyles.actorsContainer}>
                        {actors.map((actor, index) => {
                            return <ListElementforEdit
                                text={actor.TypeName}
                                description={actor.Name != null && `${actor.Name} ${actor.FatherLastName} ${actor.MotherLastName}`}
                                status='Eliminar'
                                delete={true}
                                newItem={actor.noRole}
                                arrowOnClick={(event) => { setAnchor(event, index) }}
                                clickStatus={() => openAlertToDelete(actor.Id, actor.Name != null ? `${actor.Name} ${actor.FatherLastName} ${actor.MotherLastName}` : '')}
                            />
                        })}
                    </div>
                    {actors.some((element) => element.TypeName === '') ? '' :
                        <Buttons
                            text_color="#FFFFFF"
                            background_color={theme.palette.primary.main}
                            border_color={theme.palette.primary.main}
                            text="Guardar roles"
                            type="button"
                            click={sendChange}
                        />}

                </div>

                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    onClose={closeList}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={Boolean(anchorEl)}>
                    {availableOptions.map((item) => {
                        return <MenuItem onClick={() => newRole(item.TypeName)}>
                            <ListItemIcon>
                                {item.TypeName == "Presidente" ? <AccountBoxIcon fontSize="small" /> :
                                    item.TypeName == "Tesorero" ? <MonetizationOnIcon fontSize="small" /> :
                                        item.TypeName == "Secretario" ? <PermPhoneMsgIcon fontSize="small" /> :
                                            item.TypeName == "Socio" ? <PersonIcon fontSize="small" /> :
                                                <ErrorIcon fontSize="small" />
                                }
                            </ListItemIcon>
                            {item.TypeName}
                        </MenuItem>
                    })}
                </Menu>

                <CustomAlertMaterial
                    title='Eliminar integrante'
                    body={`Estas a punto de eliminar al actor ${actorToDelete} del grupo, está acción no se puede revertir ¿Deseas continuar?`}
                    closeAction={closeAlertToDelete}
                    open={openAlert}
                    leftButtonText={t("general_cancel")}
                    leftButtonAction={closeAlertToDelete}
                    rightButtonText={t("general_accept")}
                    rightButtonAction={() => { deleteActor(idToDelete) }}
                />
                <CustomAlertHelpDialog
                    closeAction={() => { setOpenHelp(false) }}
                    open={openHelp}
                    body={
                        <div className={localStyles.insideHelpContent}>
                            <Typography
                                variant="h6"
                                gutterBottom
                                className={localStyles.wizardTitle}>
                                Editar roles
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                className={localStyles.wizardSubtitle}>
                                Para cambiar el rol de alguno de los integrantes presiona sobre el botón
                                <b>"Editar roles".</b>
                                Aplica la opción <b>"Sin rol"</b> y asigna los nuevos roles.
                            </Typography>
                            <UseImage className={localStyles.wizardImg} src={Editar_rolImg} />
                        </div>
                    }
                />

            </div>
            <div className={gridContainer.rightColumn}></div>
        </div>
    )

}

